import {
  LocalizationProvider,
  PickersActionBarAction,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV2";
import {
  DatePickerProps,
  DatePicker as MuiDatePicker,
} from "@mui/x-date-pickers/DatePicker";

type Props = Omit<DatePickerProps, "slotProps"> & {
  placeholder?: string;
  required?: boolean;
  fullWidth?: boolean;
  actions?: PickersActionBarAction[];
};

const DatePicker = (props: Props) => {
  const {
    placeholder,
    required = false,
    fullWidth = true,
    actions,
    ...pickerProps
  } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MuiDatePicker
        {...pickerProps}
        slotProps={{
          textField: {
            required,
            placeholder,
            fullWidth,
          },
          actionBar: {
            actions: actions,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
